import React from "react";

const FaqSection = ({ faqs, t }) => (
  <section className="faq anim-section home-section" id="faq">
    <div className="home-container">
      <div className="section-head">
        <h2>{t.faq.head}</h2>
        <p>{t.faq.sub}</p>
      </div>
      <div className="faq-grid">
        {faqs.map((faq) => (
          <div className="faq-item card-animated anim-card" key={faq.q}>
            <h3>{faq.q}</h3>
            <p>{faq.a}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FaqSection;
